import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Overline } from "@/components/Cards";

export default function Promotions() {
  const [promos, setPromos] = useState([]);
  useEffect(() => { api.get("/promotions").then((r) => setPromos(r.data)); }, []);
  return (
    <div>
      <Seo title="Promotions" description="Join RiNo district-wide promotions like $5 Wednesdays, First Friday Passport, and the Summer Sip & Stroll in Denver's River North Art District." />
      <PageHeader overline="District-Wide" title="RiNo Promotions" subtitle="Signature programs that unite the whole district — like our famous $5 Wednesdays." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-8" data-testid="promotions-list">
        {promos.map((p, i) => (
          <motion.div key={p.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}
            data-testid={`promotion-${p.slug}`}
            className="grid grid-cols-1 lg:grid-cols-2 border border-white/10 bg-[#141414] overflow-hidden group hover:border-[#FF0055] transition-colors">
            <div className="relative h-64 lg:h-auto overflow-hidden">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              {p.active && <span className="absolute top-4 left-4 bg-[#00FF66] text-black text-[10px] font-accent px-2 py-1">Active Now</span>}
            </div>
            <div className="p-8 lg:p-10">
              <Overline>{p.day}</Overline>
              <h2 className="font-display font-black text-3xl sm:text-4xl text-white mt-2">{p.title}</h2>
              <p className="text-[#FFEA00] font-medium mt-1">{p.subtitle}</p>
              <p className="text-neutral-400 mt-4 leading-relaxed">{p.description}</p>
              {p.participating?.length > 0 && (
                <div className="mt-6">
                  <h4 className="font-accent text-[#00E5FF] text-xs mb-3">Participating</h4>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {p.participating.map((n) => {
                      const nm = typeof n === "string" ? n : (n.name || n.business);
                      return <li key={nm} className="flex items-center gap-2 text-neutral-300 text-sm"><CheckCircle2 size={15} className="text-[#00FF66]" /> {nm}</li>;
                    })}
                  </ul>
                </div>
              )}
              <Link to={`/promotions/${p.slug}`} data-testid={`promotion-details-${p.slug}`}
                className="inline-flex items-center gap-2 mt-6 bg-[#FF0055] hover:bg-[#ff2d74] text-white text-sm font-semibold px-5 py-2.5 transition-colors">
                View Details, Offers & RSVP <ArrowRight size={15} />
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
